module.exports = __webpack_public_path__ + "img/silver.bb00577b.svg";